// @flow

import {Paper, RaisedButton, TextField} from 'material-ui';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import {forgotPassword} from '../../utils/api';
import './ForgotPassword.css';

export default class ForgotPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      loading: false,
      error: '',
      success: ''
    };
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({loading: true, error: null});
    forgotPassword(this.state.email)
      .then(res => this.setState({success: 'An email has been sent to reset your password'}))
      .catch(err => this.setState({error: 'There was a problem'}))
      .finally(() => this.setState({loading: false}))
  }

  render() {
    return (
      <main className="forgot-password">
        <div className="forgot-password__box">
          <figure className="forgot-password__logo">
            <img src={logo} alt="Zoek"/>
          </figure>
          <Paper
            className="forgot-password__paper"
            zDepth={3}
          >
            <form onSubmit={(event) => this.handleSubmit(event)}>
              <TextField
                id="email"
                hintText="Email"
                type="email"
                name="email"
                value={this.state.email}
                onChange={(event) => this.handleChange(event)}
                errorText={this.state.error}
                required
              />
              <p className="success" hidden={!this.state.success}>{this.state.success}</p>
              <br/>
              <RaisedButton
                className="forgot-password__button"
                type="submit"
                label="Forgot Password"
                primary={true}
                disabled={this.state.loading}
              />
              <br/>
              <Link
                className="forgot-password__link"
                to="/login"
              >Login?</Link>
            </form>
          </Paper>
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/ForgotPassword.js